



















import gql from 'graphql-tag';
import Vue from 'vue';

interface Client {
  id: string;
  name: string;
  country: string;
}

const query = gql`
  query {
    clients: listClient(offset: 0, limit: 100) {
      id
      name
      country
    }
  }
`;

export default Vue.extend({
  props: {
    value: {
      type: String as () => string,
    },
  },

  data() {
    return {
      clients: [],
    };
  },

  apollo: {
    clients: {
      query,
      fetchPolicy: 'cache-first',
    },
  },

  methods: {
    filterOption(input: any, option: any) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(val: string) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
});
